import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { CardManagementService } from '@app/finxone-web-frontend/app/lib/services/card-management-service/card-management-service';
import { ActionButtonOutcomesType, BaseWidgetProperties } from '@finxone-platform/shared/sys-config-types';
import { buildActionNavigationTargetUrl } from '../cta-redirection.utils';

/**
 * Shares CVV details using a web view handler.
 *
 * This function retrieves the CVV details from the provided
 * CardManagementService instance and formats them into a text
 * string. If a Flutter web view is available, it invokes the
 * 'shareSheetHandler' with the formatted text to share the
 * CVV details.
 *
 * @param cardManagementService - An instance of CardManagementService
 *                                used to access CVV details.
 */
export function shareCvvDetails(injector: Injector, widgetProperties: BaseWidgetProperties) {
  const cardManagementService = injector.get(CardManagementService);
  const router = injector.get(Router);
  const flutterWebView = (window as any).flutter_inappwebview;
  if (!cardManagementService.cvvDetails?.pan || !cardManagementService.cvvDetails?.cvv2) {
    const actionNavigationFailureUrl = buildActionNavigationTargetUrl(
      widgetProperties,
      injector,
      ActionButtonOutcomesType.FAILURE,
    );
    if (actionNavigationFailureUrl) {
      router.navigateByUrl(actionNavigationFailureUrl);
    }
    return;
  }
  const textContent = `PAN: ${cardManagementService.cvvDetails.pan}\nEXP: ${cardManagementService.cvvDetails.expDate}\nCVV: ${cardManagementService.cvvDetails.cvv2}`;
  if (flutterWebView) {
    flutterWebView.callHandler('shareSheetHandler', [textContent]);
    const actionNavigationTargetUrl = buildActionNavigationTargetUrl(
      widgetProperties,
      injector,
      ActionButtonOutcomesType.SUCCESS,
    );
    // Navigate to the success URL if it exists
    if (actionNavigationTargetUrl) {
      router.navigateByUrl(actionNavigationTargetUrl);
    }
  } else {
    const actionNavigationFailureUrl = buildActionNavigationTargetUrl(
      widgetProperties,
      injector,
      ActionButtonOutcomesType.FAILURE,
    );
    // Navigate to the failure URL if it exists
    if (actionNavigationFailureUrl) {
      router.navigateByUrl(actionNavigationFailureUrl);
    }
  }
}
